export default {
  en: {
    participants: '%{count} Going',
    participants_of_total: '%{count}/%{total} Going',
    pinned_msg: 'Pinned',
    edited_by_msg: 'Edited by %{subject}',
    event_full_msg: 'Event is full',
    hidden_reason: {
      reason_10: 'Hidden due to terms of service violation.',
      reason_20: 'Hidden due to too much advertising.',
      reason_30: 'Hidden due to no relevance.',
      reason_40: 'Hidden due to members complained.',
      reason_50: 'Notice.',
      reason_60: 'Without notice.',
    },
    hidden_reason_notice:
      'The card is hidden from the main stream to the other beUnity members. For more information please <a href="mailto:team@beunity.io">contact us</a>.',
  },
};
